import React, { useState } from 'react';
import Header from '../common/Header';
import AdminMenu from './Menu/AdminMenu';
import AdminDashboard from './Dashboard/AdminDashboard';
import ProjectsDashboard from './Dashboard/ProjectsDashboard';
import PdfDashboard from './Dashboard/PdfDashboard';
import AdminUsers from './Users/AdminUsers';
import FindUser from './Users/FindUser';
import AdminCalculations from './Calculations/AdminCalculations';
import AdminRoles from './Roles/AdminRoles';
import AdminSendEmail from './SendEmail/AdminSendEmail';
import AdminDisaster from './Disaster/AdminDisaster';
import MenuIcon from '@mui/icons-material/Menu';
import SeoHelmet from '../common/SeoHelmet';

const Admin = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [showApp, setShowApp] = useState({
    dashboard: true,
    projectsDashboard: false,
    pdfDashboard: false,
    disaster: false,
    users: false,
    findUser: false,
    roles: false,
    calculations: false,
    sendEmail: false,
  });
  const handleMenu = () => {
    setShowMenu(!showMenu);
  };
  return (
    <div className="adminContainer">
      <SeoHelmet
        title="GeoCalc | Admin"
        description="Admin dashboard for GeoCalc management."
        url="https://www.geocalc.app/admin"
        noIndex={true}
        noFollow={true}
      />

      <Header />
      <div className="adminContentContainer">
        {showMenu && (
            <AdminMenu
              setShowApp={setShowApp}
              setShowMenu={setShowMenu}
              handleMenu={handleMenu}
              showApp={showApp}
            />
          )}
        <div className="adminContent">
          {!showMenu && (
            <div className="adminMenuIcon" onClick={handleMenu}>
              <MenuIcon color="primary" />
            </div>
          )}
          {showApp.dashboard && <AdminDashboard />}
          {showApp.projectsDashboard && <ProjectsDashboard />}
          {showApp.pdfDashboard && <PdfDashboard />}
          {showApp.disaster && <AdminDisaster />}
          {showApp.users && <AdminUsers />}
          {showApp.findUser && <FindUser />}
          {showApp.calculations && <AdminCalculations />}
          {showApp.roles && <AdminRoles />}
          {showApp.sendEmail && <AdminSendEmail />}
        </div>
      </div>
    </div>
  );
};

export default Admin;
